import { Controller } from "@hotwired/stimulus"
import { isolatedCss, pooledCss } from "../modules/css_pooling_demo"

// Pooling-collision demo for "71 colliding selectors". Owns a scoped <style>
// element and swaps its contents between the isolated (per-page scoped) and
// pooled (one shared cascade) stylesheets. Every selector is prefixed with the
// widget's own id so the demo styles can never leak onto the host page.
export default class extends Controller {
  static targets = ["style", "status"]

  connect() {
    if (!this.element.id) {
      this.element.id = `cpt-${Math.random().toString(36).slice(2, 9)}`
    }
    this.scopeId = this.element.id
    // The static markup ships the isolated-state colours inline as a no-JS
    // fallback (so crawlers/no-JS readers see the collision). Now that JS is
    // running, drop those inline styles so the scoped <style> governs and the
    // toggle can actually restyle the cards.
    this.element.querySelectorAll(".section_0").forEach(el => el.removeAttribute("style"))
    this._apply(false)
  }

  toggle(event) {
    this._apply(event.currentTarget.checked)
  }

  _apply(pooled) {
    this.styleTarget.textContent = pooled ? pooledCss(this.scopeId) : isolatedCss(this.scopeId)
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = pooled
        ? "Pooled site-wide: page B's .section_0 loaded last and now restyles both cards."
        : "Isolated per page: each .section_0 is scoped to its own page."
    }
  }
}
